import * as React from 'react'

// Matches the app's historical responsive boundary: below 1024px (Tailwind `lg`)
// the sidebar behaved as an overlay/off-canvas panel.
const MOBILE_BREAKPOINT = 1024

export function useIsMobile() {
  // Seeded from the real viewport so the first paint already picks the right
  // branch; starting at `undefined` renders the desktop sidebar for one frame
  // and makes the first toggle act on the wrong variant.
  const [isMobile, setIsMobile] = React.useState(
    () => typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT
  )

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener('change', onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)

    return () => mql.removeEventListener('change', onChange)
  }, [])

  return !!isMobile
}
